const NKU_LOGGING_LEVEL = 0;

export default class Logger {
  constructor(name) {
    this.name = name;
  }

  static levels() {
    return {
      LEVEL_OFF: 0,
      LEVEL_DEBUG: 1,
      LEVEL_INFO: 2,
      LEVEL_WARN: 3
    }
  }

  log(level, str) {
    if (NKU_LOGGING_LEVEL >= level) {
      // eslint-disable-next-line no-console
      console.log(`[${Date.now()}] [${this.name}] ${str}`)
    }
  }

  debug(str) {
    this.log(Logger.levels().LEVEL_DEBUG, str);
  }

  info(str) {
    this.log(Logger.levels().LEVEL_INFO, str);
  }

  warn(str) {
    this.log(Logger.levels().LEVEL_WARN, str);
  }
}
